import { axiosInstance as axios } from "services";

export const fetchMaterialOptions = async () => {
  const { data } = await axios.get("/pricing/master/material/options");
  if (!data.success) throw new Error(data.error?.message || "Failed to fetch material options");
  return data;
};
